import { I18n } from 'i18n-js'
import { capitalize } from '../helpers'
import ca from '../translations/ca.json'
import de from '../translations/de.json'
import el from '../translations/el.json'
import en from '../translations/en.json'
import es from '../translations/es.json'
import eu from '../translations/eu.json'
import fr from '../translations/fr.json'
import hr from '../translations/hr.json'
import hu from '../translations/hu.json'
import it from '../translations/it.json'
import nl from '../translations/nl.json'
import pt from '../translations/pt.json'
import si from '../translations/si.json'

const i18n = new I18n({
  ca,
  de,
  el,
  en,
  es,
  eu,
  fr,
  hr,
  hu,
  it,
  nl,
  pt,
  si
})
i18n.enableFallback = true

export type Language = 'ca' | 'de' | 'el' | 'en' | 'es' | 'eu' | 'fr' | 'hr' | 'hu' | 'it' | 'nl' | 'pt' | 'si'

class LiteralsService {
  private language = this.getDefaultLanguageForTranslations()

  constructor() {}

  public get(key: string, capitalized = false): string {
    const res = this.getKey(key)
    return capitalized ? capitalize(res) : res
  }

  public getOrDefault(key: string | undefined | null, fallbackKey: string, capitalized: boolean = false): string {
    if (key && i18n.translations[this.language] && (i18n.translations[this.language] as any)[key]) {
      return this.get(key, capitalized)
    }
    if (key && i18n.translations[this.getDefaultLanguageForTranslations()] && (i18n.translations[this.getDefaultLanguageForTranslations()] as any)[key]) {
      return this.get(key, capitalized)
    }
    return this.get(fallbackKey, capitalized)
  }

  // A language picker names every option in its own language, not in the one
  // the interface happens to be using.
  public getInLanguage(key: string, language: string, capitalized = false): string {
    const res = i18n.t(key, { locale: language }) || key
    return capitalized ? capitalize(res) : res
  }

  public isLanguageActive(language: string): boolean {
    return this.language === language
  }

  public setLanguage(language: string): void {
    this.language = language
  }

  public getLanguage(): string {
    return this.language
  }

  public getDefaultLanguageForTranslations(): string {
    let language = 'en'
    const availableLocales = Object.keys(i18n.translations)
    availableLocales.forEach((lang: string) => {
      if (lang === navigator.language.split('-')[0]) language = lang
    })
    return language
  }

  private getKey(key: string): string {
    return i18n.t(key, {locale: this.language}) || key
  }
}

export default new LiteralsService()
